import { observer } from 'mobx-react-lite';
import React from 'react';
import { withDefaultProps } from 'react-default-props-context';
import { AnswerListView } from 'src/answers/components';
import { QuestionT } from 'src/api/types/QuestionT';
import { Portal } from 'src/frames/components/Portal';
import { useScrollToTop } from 'src/frames/components/useScrollToTop';
import { HintIcon } from 'src/frames/icons/HintIcon';
import { cn } from 'src/frames/utils/cn';
import { BackButton } from 'src/questions/components/BackButton';
import { HintView } from 'src/questions/components/HintView';
import { ProgressBar } from 'src/questions/components/ProgressBar';
import { SkipButton } from 'src/questions/components/SkipButton';
import './QuestionView.scss';

type PropsT = {
  className?: any;
};

type DefaultPropsT = {
  question: QuestionT;
  questionDisplayNr: number;
  portalElm: any;
};

export const QuestionView = observer(
  withDefaultProps<PropsT, DefaultPropsT>((props: PropsT & DefaultPropsT) => {
    useScrollToTop('SelfTestView', 'QuestionView');

    const [showHint, setShowHint] = React.useState(false);

    return showHint ? (
      <HintView setShowHint={setShowHint} />
    ) : (
      <div
        id="QuestionView"
        className={cn('QuestionView', 'flex flex-col', props.className)}
      >
        <Portal elm={props.portalElm}>
          <BackButton className="mr-6" />
          <div className="QuestionView__Title">
            <div className="QuestionView__Text">{ props.question.text }</div>
            {props.question.hintTitle && props.question.hint && (
              <div className={cn('QuestionView__Hint')}>
                <button
                  onClick={() => {
                    setShowHint(!showHint);
                  }}
                >
                  <HintIcon />
                </button>
              </div>
            )}
          </div>
        </Portal>
        <ProgressBar />
        <div
          className={cn(
            'QuestionView__Card',
            'flex flex-col',
            'flex-1',
            'px-4',
            'py-2 tall:py-4'
          )}
        >
          <AnswerListView />
          <div className="basis-0 grow shrink"></div>
          {props.question.isSkippable && <SkipButton className={cn('my-3')} />}
        </div>
      </div>
    );
  })
);
